import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { SearchThemeSelectorImpl } from './search-theme-selector-section-impl';

export const SearchThemeSelector = ({
  searchThemes, onUpdateSearchThemes,
}) => (
  <SearchThemeSelectorImpl searchThemes={searchThemes} onUpdateSearchThemes={onUpdateSearchThemes} />
);

SearchThemeSelector.propTypes = {
  searchThemes: PropTypes.arrayOf(PropTypes.shape({})),
  onUpdateSearchThemes: PropTypes.func.isRequired,
};
SearchThemeSelector.defaultProps = {
  searchThemes: [],
};

export const ValidationSearchThemeSelectorInternal = ({
  searchThemes, updateValidation,
}) => {
  const onUpdateSearchThemes = useCallback((newsearchThemes) => {
    updateValidation([], { AssetGroupSearchThemes: [...newsearchThemes] });
  }, [updateValidation]);
  return <SearchThemeSelectorImpl searchThemes={searchThemes} onUpdateSearchThemes={onUpdateSearchThemes} />;
};
ValidationSearchThemeSelectorInternal.propTypes = {
  searchThemes: PropTypes.arrayOf(PropTypes.shape({})),
  updateValidation: PropTypes.func.isRequired,
};
ValidationSearchThemeSelectorInternal.defaultProps = {
  searchThemes: [],
};
export const ValidationSearchThemeSelector = withCustomValidation(ValidationSearchThemeSelectorInternal);
